const CODE_MAP = {
  INVALID_PAYLOAD: {
    severity: "error",
    title: "Invalid request",
    message: "Please review the form details and try again.",
  },
  UNAUTHORIZED: {
    severity: "error",
    title: "Session expired",
    message: "Please reload the page and sign in again.",
  },
  FORBIDDEN: {
    severity: "error",
    title: "Not authorized",
    message: "You do not have permission to access this feature.",
  },
  NOT_FOUND: {
    severity: "info",
    title: "Data not found",
    message: "There is nothing to show here yet.",
  },
  BILLING_CREDITS_EXHAUSTED: {
    severity: "warning",
    title: "Action blocked",
    message: "Your credits are exhausted. Please top up to continue.",
  },
};

const DEFAULT_NORMALIZED = {
  severity: "error",
  title: "Something went wrong",
  message: "We could not complete the request. Please try again.",
};

const isNormalizedShape = (value) =>
  value &&
  typeof value === "object" &&
  typeof value.title === "string" &&
  typeof value.message === "string";

const normalizeStatusCode = (status) => {
  if (status === 401) return "UNAUTHORIZED";
  if (status === 403) return "FORBIDDEN";
  if (status === 404) return "NOT_FOUND";
  return null;
};

const extractErrorDetails = (error) => {
  if (!error) {
    return { status: null, code: null, message: "" };
  }
  if (typeof error === "string") {
    return { status: null, code: null, message: error };
  }
  const response = error.response || error?.data?.response;
  const status =
    response?.status ||
    error?.status ||
    error?.response?.data?.status ||
    null;
  const code =
    response?.data?.code ||
    error?.code ||
    error?.errorCode ||
    error?.data?.code ||
    null;
  const message =
    response?.data?.message ||
    error?.message ||
    error?.data?.message ||
    "";
  return { status, code, message };
};

const toNormalized = ({ status, code, message }) => {
  const derivedCode = normalizeStatusCode(status);
  const finalCode = (code || derivedCode || "").toString().toUpperCase();
  const mapped = CODE_MAP[finalCode];

  if (mapped) {
    return {
      ...mapped,
      code: finalCode || undefined,
    };
  }

  return {
    ...DEFAULT_NORMALIZED,
    message: message || DEFAULT_NORMALIZED.message,
    code: finalCode || undefined,
  };
};

export default function normalizeApiError(error) {
  try {
    if (isNormalizedShape(error)) {
      return {
        severity: error.severity || DEFAULT_NORMALIZED.severity,
        title: error.title,
        message: error.message,
        code: error.code,
      };
    }
    const details = extractErrorDetails(error);
    return toNormalized(details);
  } catch (err) {
    return { ...DEFAULT_NORMALIZED };
  }
}
